<template>
  <div ref="scrollWrapper" class="category-tabs-component">
    <ul class="content">
      <li
        v-for="(item, index) in list"
        :key="item.id"
        ref="scrollItem"
        :style="{
          marginLeft: index !== 0 ? `${gutter}px` : 0,
          marginRight: index !== list.length - 1 ? `${gutter}px` : 0
        }"
        :class="{ selected: index == current }"
        @click="e => tabChange(item, index, e)"
      >
        <slot :item="item" :index="index"> {{ item.name }} </slot>
      </li>
    </ul>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    // 当前分类索引
    current: {
      type: Number,
      default: 0
    },
    gutter: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      // better-scroll实例
      bs: null,
      // 记录上一次scrollX，防止两次相同scrollX造成scrollEnd失效
      preX: 0
    }
  },
  computed: {
    wrapperWidth() {
      return this.$refs.scrollWrapper.offsetWidth
    },
    contentWidth() {
      return this.$refs.scrollWrapper.childNodes[0].offsetWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.bs = new BScroll(this.$refs.scrollWrapper, {
        click: true,
        scrollX: true,
        bounceTime: 500
      })
      this.scrollToCurrentItem(this.current)
    })
  },
  beforeDestroy() {
    this.bs.destroy()
  },
  methods: {
    tabChange(item, index, e) {
      e.preventDefault()

      this.scrollToCurrentItem(index)
      this.$emit('tab-change', item, index)
    },
    // 滚动到指定元素
    scrollToCurrentItem(index) {
      if (this.contentWidth > this.wrapperWidth) {
        // 当前点击元素滚动到中间（点击位置处于中间之前的元素scrollTO(0)）
        const curLeft = this.$refs.scrollItem[index].offsetLeft
        const centerPoint = Math.ceil(this.wrapperWidth / 2)
        let x = curLeft - centerPoint
        x = x > 0 ? -x : 0
        if (this.preX != x) {
          this.bs.scrollTo(x)
          this.preX = x
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.category-tabs-component {
  width: 100%;
  position: relative;
  overflow: hidden;
  .content {
    white-space: nowrap;
    display: inline-block;
    li {
      display: inline-block;
      cursor: pointer;
      &:hover {
        color: $text-color-primary;
      }
      &.selected {
        font-weight: bold;
        color: $text-color-primary;
      }
    }
  }
}
</style>
